import { render, staticRenderFns } from "./TaskGroupsModal.vue?vue&type=template&id=03013f8e&scoped=true&"
import script from "./TaskGroupsModal.vue?vue&type=script&lang=js&"
export * from "./TaskGroupsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03013f8e",
  null
  
)

export default component.exports